import { render, staticRenderFns } from "./goodsAnalyze.vue?vue&type=template&id=552ad71b&scoped=true"
import script from "./goodsAnalyze.vue?vue&type=script&lang=js"
export * from "./goodsAnalyze.vue?vue&type=script&lang=js"
import style0 from "./goodsAnalyze.vue?vue&type=style&index=0&id=552ad71b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ad71b",
  null
  
)

export default component.exports